import {
  HeroSection,
  GitHubIssueShowcaseSection,
  BeforeAfterSection,
  HowItWorksSection,
  FeaturesSection,
  IntegrationsSection,
  FAQSection,
  UrgencyCTASection,
} from "@/shared/hero-section";
import {
  createSoftwareApplicationSchema,
  createWebPageSchema,
} from "@/utils/structured-data";
import { WebLayout } from "@/web/layout/web-layout";

export function MainLanding() {
  const softwareSchema = createSoftwareApplicationSchema();
  const webpageSchema = createWebPageSchema(
    "https://vivus.cz",
    "Automatic K8s, CI/CD & OpenTelemetry monitoring with AI-powered issue triage. Detect Kubernetes crashes, pipeline failures, and OpenTelemetry errors automatically. Free while in beta.",
    "Automatic K8s, CI/CD & OpenTelemetry Monitoring",
    "vivus"
  );

  return (
    <WebLayout>
      {/* Page-specific Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(softwareSchema, null, 0),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(webpageSchema, null, 0),
        }}
      />
      <div>
        <HeroSection />
        <GitHubIssueShowcaseSection />
        <BeforeAfterSection />
        <HowItWorksSection />
        <FeaturesSection />
        <IntegrationsSection />
        <FAQSection />
        <UrgencyCTASection />
      </div>
    </WebLayout>
  );
}
